export default "__VITE_ASSET__Yg69898V__"